import {createRequestActionTypes} from "@pg-mono/request-state";

const FETCH_RECOMMENDED_OFFERS_PREFIX = "similar_offers/FETCH_RECOMMENDED_OFFERS_PREFIX";
export const fetchRecommendedOfferTypes = createRequestActionTypes(FETCH_RECOMMENDED_OFFERS_PREFIX);

/**
 * @deprecated
 */
export const resetRecommendedOffers = () => ({
    type: fetchRecommendedOfferTypes.reset
});
import {createRequestActionTypes} from "@pg-mono/request-state";

const FETCH_RECOMMENDED_OFFERS_PREFIX = "similar_offers/FETCH_RECOMMENDED_OFFERS_PREFIX";
export const fetchRecommendedOfferTypes = createRequestActionTypes(FETCH_RECOMMENDED_OFFERS_PREFIX);

/**
 * @deprecated
 */
export const resetRecommendedOffers = () => ({
    type: fetchRecommendedOfferTypes.reset
});
